import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import util from '@/util'

export default {
  components: {
    DatePick
  },
  computed: {
    defaultClass () {
      let defaultClass = this.classField
      if (defaultClass !== null && defaultClass !== undefined) {
        defaultClass += ' defaultRules'
      }
      return defaultClass
    }
  },
  data: () => ({
    inputValue: null,
    recebeuParametroValue: false
  }),
  props: {
    disabled: Boolean,
    value: [String, Date],
    classField: String,
    placeholder: String,
    id: String
  },
  methods: {
    retornarValor (valor) {
      valor = valor.replace(/\D/g, '')
      valor = valor.replace(/(\d{2})(\d)/, '$1/$2')
      valor = valor.replace(/(\d{2})(\d)/, '$1/$2')
      this.$refs.datePick.inputValue = valor
      if (valor.length === 10) {
        valor = util.formatarDataBRParaISO(valor)
      }
      this.$emit('input', valor)
    }
  },
  watch: {
    value (valorAtual) {
      if (!util.valorEhNulo(valorAtual) && this.recebeuParametroValue === false) {
        if (valorAtual !== 'Invalid Date' && this.inputValue === null) {
          if (util.ehValidoFormatoData(valorAtual, 'YYYY-MM-DD')) {
            this.inputValue = util.formatarData(valorAtual, 'DD/MM/YYYY')
            this.recebeuParametroValue = true
          }
        }
      }
    }
  },
  render (h) {
    return h('date-pick', {
      ref: 'datePick',
      props: {
        value: this.inputValue,
        format: 'DD/MM/YYYY',
        displayFormat: 'DD/MM/YYYY',
        editable: !this.disabled,
        inputAttributes: {
          maxlength: 10,
          class: this.defaultClass,
          disabled: this.disabled,
          id: this.id
        },
        nextMonthCaption: 'Próximo mês',
        prevMonthCaption: 'Mês anterior',
        setTimeCaption: 'Definir horário',
        weekdays: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        months: [
          'Janeiro', 'Fevereiro', 'Março', 'Abril',
          'Maio', 'Junho', 'Julho', 'Agosto',
          'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ]
      },
      on: {
        input: this.retornarValor
      }
    })
  }
}
